function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function get(target, property, receiver) {
            var base = _super_prop_base(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver || target);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _get_prototype_of(object);
        if (object === null) break;
    }
    return object;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { getChannelSettings, setChannelSettings, setProfileSettings } from "@common/actions";
import EditForm from "@common/components/EditForm";
import SettingItem from "@common/components/Settings/SettingItem";
import Spinner from "@common/components/Spinner";
import { deleteSessionLockTime } from "@common/services/helpers";
import { changeWebSetting } from "@common/utils/helpers";
import { SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR, SNACKBAR_VARIANT_SUCCESS } from "@config/constants";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { isEmpty, isEqual } from "lodash";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
var EditPin = /*#__PURE__*/ function(SettingItem) {
    "use strict";
    _inherits(EditPin, SettingItem);
    var _super = _create_super(EditPin);
    function EditPin(props) {
        _class_call_check(this, EditPin);
        var _this;
        _this = _super.call(this, props);
        var _this1 = _assert_this_initialized(_this);
        _define_property(_assert_this_initialized(_this), "save", /*#__PURE__*/ _async_to_generator(function() {
            var _this_props, settingsChannelsConfig, _$setChannelSettings, enqueueSnackbar, i18n, _$setProfileSettings, profileSettings, pinForm;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this_props = _this1.props, settingsChannelsConfig = _this_props.settingsChannelsConfig, _$setChannelSettings = _this_props.setChannelSettings, enqueueSnackbar = _this_props.enqueueSnackbar, i18n = _this_props.i18n, _$setProfileSettings = _this_props.setProfileSettings, profileSettings = _this_props.profileSettings;
                        pinForm = _this1.state.pinForm;
                        // Reset timeToLockChannels
                        return [
                            4,
                            _$setProfileSettings(changeWebSetting(profileSettings, {
                                timeToLockChannels: null
                            }))
                        ];
                    case 1:
                        _state.sent();
                        // Save new pin
                        return [
                            4,
                            _$setChannelSettings(settingsChannelsConfig, pinForm.newPin)
                        ];
                    case 2:
                        _state.sent();
                        _this1.toggleEdit();
                        //
                        enqueueSnackbar(i18n.settings.PINSuccess, {
                            variant: SNACKBAR_VARIANT_SUCCESS,
                            autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                        });
                        return [
                            2
                        ];
                }
            });
        }));
        _define_property(_assert_this_initialized(_this), "renderLeftButton", function() {
            if (!_this.state.editting) {
                return undefined;
            }
            return /*#__PURE__*/ _jsxs(Button, {
                classes: {
                    label: "ux-button-label"
                },
                onClick: _this.toggleEdit,
                className: "go-back-button raised half-width",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "icon icon-keyboard-arrow-right"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: _this.props.i18n.common.back
                    })
                ]
            });
        });
        _define_property(_assert_this_initialized(_this), "renderSaveButton", function() {
            var _this_state = _this.state, pinForm = _this_state.pinForm, formError = _this_state.formError;
            var saveEnabled = Object.values(formError).every(function(e) {
                return !e;
            }) && Object.values(pinForm).every(function(e) {
                return e.length === 4;
            });
            return /*#__PURE__*/ _jsx(Button, {
                onClick: _this.save,
                disabled: !saveEnabled
            });
        });
        _define_property(_assert_this_initialized(_this), "toggleEdit", function() {
            var editting = _this.state.editting;
            _this.setState({
                editting: !editting,
                pinForm: _this.initialPinForm
            });
        });
        _define_property(_assert_this_initialized(_this), "validateForm", function(name) {
            var _this_state_pinForm = _this.state.pinForm, currentPin = _this_state_pinForm.currentPin, newPin = _this_state_pinForm.newPin, newPinRepeat = _this_state_pinForm.newPinRepeat;
            var _this_props = _this.props, settingsChannelsConfig = _this_props.settingsChannelsConfig, i18n = _this_props.i18n;
            var _currentPin = settingsChannelsConfig.lockedPIN || settingsChannelsConfig.defaultPIN;
            var testLenght = function(value) {
                return value.length !== 4 && i18n.settings.addFourDigitPin;
            };
            var testCorrectPin = function(value, otherValue) {
                return value !== otherValue && i18n.settings.incorrentPin;
            };
            var testEqualPin = function(value, otherValue) {
                return testCorrectPin(value, otherValue) && i18n.settings.PINDontMatch;
            };
            var formErrorMap = {
                currentPin: testLenght(currentPin) || testCorrectPin(currentPin, _currentPin),
                newPin: testLenght(newPin),
                newPinRepeat: testLenght(newPinRepeat) || testEqualPin(newPin, newPinRepeat)
            };
            var formError = _object_spread_props(_object_spread({}, _this.state.formError), _define_property({}, name, formErrorMap[name]));
            _this.setState({
                formError: formError
            });
        });
        _define_property(_assert_this_initialized(_this), "handleInputFields", function(event) {
            var _event_target = event.target, value = _event_target.value, name = _event_target.name;
            var length = value === null || value === void 0 ? void 0 : value.length;
            // Max Lenght 4
            if (length > 4) {
                return;
            }
            var pinForm = _object_spread_props(_object_spread({}, _this.state.pinForm), // Strip out symbols
            _define_property({}, name, value.replace(/[^0-9]/g, "")));
            _this.setState({
                pinForm: pinForm
            }, function() {
                // Validate form
                if (length === 4 || length === 0) {
                    // Clear error for form input
                    var formError = _object_spread_props(_object_spread({}, _this.state.formError), _define_property({}, name, ""));
                    !length ? _this.setState({
                        formError: formError
                    }) : _this.validateForm(name);
                }
            });
        });
        _define_property(_assert_this_initialized(_this), "handleBlur", function(event) {
            _this.validateForm(event.target.name);
        });
        _define_property(_assert_this_initialized(_this), "renderPinPlaceHolder", function() {
            return /*#__PURE__*/ _jsx(TextField, {
                name: "password placeholder",
                defaultValue: "****",
                type: "password",
                className: "ux-text-field-root ux-input",
                label: _this.props.i18n.settings.currentPin,
                required: true,
                disabled: true,
                InputProps: {
                    style: {
                        fontSize: "1.6rem"
                    },
                    className: "ux-input"
                },
                InputLabelProps: {
                    style: {
                        fontSize: "1.6rem"
                    },
                    className: "ux-input"
                },
                margin: "none"
            }, "password placeholder");
        });
        _define_property(_assert_this_initialized(_this), "renderEditPin", function() {
            var pinForm = _this.state.pinForm;
            var commonProps = {
                type: "password",
                className: "ux-text-field-root ux-input",
                required: true,
                autoComplete: false,
                InputProps: {
                    style: {
                        fontSize: "1.6rem"
                    },
                    className: "ux-input"
                },
                InputLabelProps: {
                    style: {
                        fontSize: "1.4rem"
                    },
                    className: "ux-input"
                },
                FormHelperTextProps: {
                    error: true,
                    classes: {
                        root: "ux-form-helper-text"
                    }
                },
                margin: "dense"
            };
            var inputMap = [
                {
                    name: "currentPin",
                    value: pinForm.currentPin,
                    label: _this.props.i18n.settings.enterOldPIN
                },
                {
                    name: "newPin",
                    value: pinForm.newPin,
                    label: _this.props.i18n.settings.enterNewPIN
                },
                {
                    name: "newPinRepeat",
                    value: pinForm.newPinRepeat,
                    label: _this.props.i18n.settings.repeatNewPIN
                }
            ];
            return inputMap.map(function(el, index) {
                var error = _this.state.formError[el.name];
                return /*#__PURE__*/ _createElement(TextField, _object_spread_props(_object_spread({}, el, commonProps), {
                    autoFocus: index === 0,
                    key: el.name,
                    error: !isEmpty(error),
                    helperText: error,
                    onBlur: _this.handleBlur,
                    onChange: _this.handleInputFields
                }));
            });
        });
        _define_property(_assert_this_initialized(_this), "onEditChange", function(editting) {
            var onEditPinToggle = _this.props.onEditPinToggle;
            _this.setState({
                editting: editting
            });
            onEditPinToggle && onEditPinToggle(editting);
        });
        _this.initialPinForm = {
            currentPin: "",
            newPin: "",
            newPinRepeat: ""
        };
        _this.state = {
            editting: false,
            pinForm: _this.initialPinForm,
            formError: _this.initialPinForm,
            saving: false
        };
        return _this;
    }
    _create_class(EditPin, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var settingsChannelsConfig = this.props.settingsChannelsConfig;
                isEmpty(settingsChannelsConfig) && this.props.getChannelSettings();
                _get(_get_prototype_of(EditPin.prototype), "componentDidMount", this).call(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsx(EditForm, {
                    title: i18n.settings.changePin,
                    onEditChange: this.onEditChange,
                    editting: this.state.editting,
                    iconClassName: "icon-2 icon-settings-font-lock icon",
                    editView: this.renderEditPin(),
                    readView: this.renderPinPlaceHolder()
                });
            }
        }
    ]);
    return EditPin;
}(SettingItem);
var mapStateToProps = function(param) {
    var i18n = param.i18n, profileSettings = param.profileSettings, settingsChannelsConfig = param.settingsChannelsConfig;
    return {
        i18n: i18n,
        profileSettings: profileSettings,
        settingsChannelsConfig: settingsChannelsConfig
    };
};
export default withSnackbar(connect(mapStateToProps, {
    getChannelSettings: getChannelSettings,
    setChannelSettings: setChannelSettings,
    setProfileSettings: setProfileSettings
})(EditPin));
